import {CoreMenu} from '@core/types'
import {signableForm} from './custom-menu-svg'
import {LEGAL_HUB_URL} from "../main/pages/legal-hub/legal-hub-consts";

export const menu: CoreMenu[] = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    translate: 'Collapsible menu title (Collapsible sidebar - section) - Dashboard',
    type: 'item',
    icon: 'home',
    url: 'dashboard'
  },
  {
    id: 'contacts',
    title: 'Contacts',
    translate: 'Collapsible menu title (Collapsible sidebar - section) - Contacts',
    type: 'collapsible',
    icon: 'users',
    children: [
      {
        id: 'Private',
        title: 'Contact',
        translate: 'Collapsible sub menu title (Collapsible sidebar - section) - Contact',
        type: 'item',
        icon: 'circle',
        url: '/contacts/recipients'
      },
      {
        id: 'Organizations',
        title: 'Organizations',
        translate: 'Collapsible sub menu title (Collapsible sidebar - section) - Organizations',
        type: 'item',
        icon: 'circle',
        url: '/contacts/organizations'
      }
    ]
  },
  {
    id: 'templates',
    title: 'Templates',
    translate: 'Collapsible menu title (Collapsible sidebar - section) - Templates',
    type: 'item',
    icon: 'file-text',
    url: 'templates'
  },
  {
    id: 'signable-form',
    title: 'Signable form',
    translate: 'Collapsible menu title (Collapsible sidebar - section) - Signable form',
    type: 'item',
    icon: signableForm,
    url: 'signable-form',
    hasSvgIcon: true,
  },
  {
      id: 'legalHub',
      title: 'Templates',
      translate: 'Legal hub menu title (Collapsible sidebar - section) -  Legal Hub',
      type: 'item',
      icon: 'legal-hub',
      url: LEGAL_HUB_URL
  },  
  {
    id: 'settings',
    title: 'Settings',
    translate: 'Collapsible menu title (Collapsible sidebar - section) - Settings',
    type: 'collapsible',
    icon: 'settings',
    children: [
      {
        id: 'APIsettings',
        title: 'API Keys',
        translate: 'Collapsible sub menu title (Collapsible sidebar - section) - API Keys',
        type: 'item',
        icon: 'circle',
        url: 'settings/apisettings'
      },
      {
        id: 'branding',
        title: 'Branding',
        translate: 'Collapsible sub menu title (Collapsible sidebar - section) - Branding',
        type: 'item',
        icon: 'circle',
        url: 'settings/branding'
      },
      {
        id: 'categories',
        title: 'Categories',
        translate: 'Collapsible sub menu title (Collapsible sidebar - section) - Categories',
        type: 'item',
        icon: 'circle',
        url: 'settings/categories'
      },
      {
        id: 'contentlibrary',
        title: 'Content library',
        translate: 'Collapsible sub menu title (Collapsible sidebar - section) - Content library',
        type: 'item',
        icon: 'circle',
        url: 'settings/contentlibrary'
      },
      {
        id: 'productlibrary',
        title: 'Product library',
        translate: 'Product Library text for access type (Roles Section) - Product Library',
        type: 'item',
        icon: 'circle',
        url: 'settings/productlibrary'
      },
      {
        id: 'documenttype',
        title: 'Document Type',
        translate: 'Collapsible sub menu title (Collapsible sidebar - section) - Document Type',
        type: 'item',
        icon: 'circle',
        url: 'settings/documenttype'
      },
      // {
      //   id: 'bulksend',
      //   title: 'My list',
      //   translate: 'Collapsible sub menu title (Collapsible sidebar - section) - My list',
      //   type: 'item',
      //   icon: 'circle',
      //   url: 'settings/bulksend'
      // },
      {
        id: 'general',
        title: 'General',
        translate: 'Collapsible sub menu title (Collapsible sidebar - section) - General',
        type: 'item',
        icon: 'circle',
        url: 'settings/company'
      },
      {
        id: 'MD',
        title: 'Meta Data',
        translate: 'Collapsible sub menu title (Collapsible sidebar - section) - Meta Data',
        type: 'item',
        icon: 'circle',
        url: 'settings/meta-data',
        hidden: false,
      },
    ]
  },
  {
    id: 'Add_Ons',
    title: 'Add-Ons',
    translate: 'Collapsible menu title (Collapsible sidebar - section) - Add-Ons',
    type: 'item',
    icon: 'command',
    url: 'addons/addons'
  },
]
